import { Box, styled, Typography, type CSSObject } from '@mui/material';

interface StyledTextWrapperProps {
  variant?: 'top' | 'bottom';
}

export const StyledTextWrapper = styled(Box)<StyledTextWrapperProps>(
  ({ theme, variant = 'top' }) => ({
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    width: 'fit-content',
    paddingInline: theme.spacing(1.5),
    ...(variant === 'top'
      ? {
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          paddingTop: theme.spacing(0.5),
        }
      : {
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
          borderTopRightRadius: 8,
          paddingBottom: theme.spacing(0.5),
        }),
  })
);

export const StyledText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 800,
  lineHeight: 1.3,
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));
